export default __webpack_public_path__ + "static/Lilly4-b22a229f097c46e2c6de63d8e2405809.jpg";